import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'
import { SnapType as SnapTypes } from 'canvas/lib/support/snap'
import _ from 'lodash'
import deviceType from 'scoreboard/components/device-type'
import Tooltip from 'scoreboard/components/tooltip'
import bootslideOption from 'scoreboard/components/bootslide/option.hbs'
import $ from 'jquery'
import WidgetState from 'scoreboard/forms/model/widget-state'
import FilterSourceDialog from 'scoreboard/forms/widgets/filter-source-dialog'
import appDisplay from 'scoreboard/components/app-display'
const { VISIBLE, HIDDEN } = WidgetState

const SettingsMenu = BootslideMenu.extend({
	menu: function () {
		let targets = []

		targets.push({
			label: i18n.get('dashboards.toolbar.snap.heading'),
			content: function() {
				return $('<div></div>').append(
					bootslideOption({icon: 'snap', label: 'dashboards.toolbar.snap.heading'}))
			},
			target: _.values(SnapTypes).map(type => {
				return {
					contentView: SnapToOption.extend({
						label: i18n.get(`dashboards.toolbar.snap.${type.toLowerCase()}`),
						value: type
					})
				}
			}),
			width: MENU_WIDTH
		})

		if (this.options.formWidget) {
			targets.unshift(this.createFilterSourceMenu())
			targets.push(this.createWidgetVisibilityMenu())
		} else {
			// #56207 dashboards in a form widget are always white background
			targets.push(this.createBackgroundMenu())
		}

		return {
			label: i18n.get('common.settings'),
			target: targets,
			width: MENU_WIDTH
		}
	},

	createBackgroundMenu () {
		return {
			label: i18n.get('dashboards.backgroundColor'),
			content: function () {
				return $('<div></div>').append(
					bootslideOption({
						icon: 'background-color',
						label: 'dashboards.backgroundColor'
					}))
			},
			target: ['gray', 'white'].map(type => {
				return {
					contentView: BootslideMenu.MultipleChoiceOption.extend({
						property: 'background',
						label: i18n.get(`dashboards.backgroundColor.${type.toLowerCase()}`),
						value: type
					})
				}
			}),
			width: MENU_WIDTH
		}
	},

	createFilterSourceMenu () {
		return {
			type: 'dialog',
			label: 'datasets.filters.set',
			target: e => {
				let dialog = new FilterSourceDialog({
					model: this.options.formWidget,
					form: this.options.form
				})

				dialog.on('done', () => {
					let val = dialog.val()
					let isUnsavedWidget = val.startsWith('w')
					this.options.formWidget.set({
						filterSourceWidgetId: isUnsavedWidget ? null : val,
						filterSourceWidgetTempId: isUnsavedWidget ? val : null
					})
				})

				appDisplay.dialog(dialog)

				this.trigger('done')
			}
		}
	},

	createWidgetVisibilityMenu () {
		return {
			type: 'toggle',
			model: this.options.formWidget,
			contentView: BootslideMenu.ToggleProperty.extend({
				property: {
					label: 'forms.fieldWidget.type.visible',
					name: 'state'
				},

				val () {
					return this.model.get('state') === VISIBLE
				},

				updateModel (newVal) {
					this.model.set('state', newVal ? VISIBLE : HIDDEN)
				}
			})
		}
	}
})

const MENU_WIDTH = 200

const SnapToOption = BootslideMenu.MultipleChoiceOption.extend({
	property: 'snapType',

	events: _.extend({
		'mouseout': 'removeDisabledTooltip'
	}, BootslideMenu.MultipleChoiceOption.prototype.events),

	select() {
		if (this.disabled) {
			if (this.disabledTooltip) {
				this.removeDisabledTooltip()
			} else {
				this.disabledTooltip = new Tooltip({
					attachTo: this.el,
					content: i18n.get('dashboards.toolbar.snap.disabled'),
					placement: 'left',
					arrow: 'center',
					ignoreAttachToClick: true
				}).render()
			}
		} else {
			BootslideMenu.MultipleChoiceOption.prototype.select.apply(this, arguments)
		}
	},

	remove() {
		BootslideMenu.MultipleChoiceOption.prototype.remove.apply(this, arguments)
		this.removeDisabledTooltip()
	},

	removeDisabledTooltip() {
		this.disabledTooltip && this.disabledTooltip.remove()
		delete this.disabledTooltip
	}
})

export default SettingsMenu

SettingsMenu.__filename__ = 'dashboards/edit/dashboard-settings.js'
